const SESSION_EXPIRED_EVENT = "nelo:session-expired"

export const emitSessionExpired = (): void => {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT))
}

export const onSessionExpired = (handler: () => void): (() => void) => {
  if (typeof window === "undefined") return () => {}
  window.addEventListener(SESSION_EXPIRED_EVENT, handler)
  return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler)
}
